var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "tool" }, [
                  _c("h4", [_vm._v("选择客户")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择客户",
                            loading: _vm.customerLoading,
                            filterable: ""
                          },
                          on: { change: _vm.customerChange },
                          model: {
                            value: _vm.customerValue,
                            callback: function($$v) {
                              _vm.customerValue = $$v
                            },
                            expression: "customerValue"
                          }
                        },
                        _vm._l(_vm.customerData, function(item) {
                          return _c("el-option", {
                            key: item.client_id,
                            attrs: {
                              label: item.number + " " + item.client_name,
                              value: item.client_id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "part" },
                  [
                    _c("div", { staticClass: "prompt_header" }, [
                      _c("h5", [_vm._v("提示词")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "prompt_actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                plain: "",
                                disabled: !_vm.prompt || !_vm.prompt.trim()
                              },
                              on: { click: _vm.handleAIEnhance }
                            },
                            [
                              _c("i", { staticClass: "el-icon-magic-stick" }),
                              _vm._v(" AI扩写润色\n              ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                plain: ""
                              },
                              on: { click: _vm.handlePromptLibrary }
                            },
                            [
                              _c("i", { staticClass: "el-icon-reading" }),
                              _vm._v(" 提示词库\n              ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.imageToPromptVisible = true
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-picture" }),
                              _vm._v(" 图转提示词\n              ")
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 6,
                        placeholder:
                          "输入描述内容，例如：现代简约办公室，自然光，木地板，温暖的色调",
                        maxlength: "1000",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.prompt,
                        callback: function($$v) {
                          _vm.prompt = $$v
                        },
                        expression: "prompt"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("h5", [_vm._v("AI大模型（最多选择3个）")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { max: 3 },
                          model: {
                            value: _vm.aiSelected,
                            callback: function($$v) {
                              _vm.aiSelected = $$v
                            },
                            expression: "aiSelected"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ai_box" },
                            _vm._l(_vm.aiModels, function(item, index) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: "ai" + index,
                                  attrs: { label: item.model_id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.model_name + "(" + item.price + ")"
                                    )
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn_save" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "success",
                          loading: _vm.isGenerating,
                          disabled:
                            !_vm.prompt ||
                            !_vm.customerValue ||
                            _vm.aiSelected.length === 0
                        },
                        on: { click: _vm.handleGenerate }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isGenerating
                                ? "生成中..."
                                : "立即生成" +
                                    (_vm.aiSelected.length > 0
                                      ? "（" +
                                        _vm.aiSelected.length +
                                        "个模型）"
                                      : "")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(
                        "（本月剩余使用额度 " +
                          _vm._s(_vm.global.money) +
                          "元）"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.generatedImages.length > 0
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("生成结果")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "result_grid" },
                        _vm._l(_vm.generatedImages, function(img, index) {
                          return _c(
                            "div",
                            {
                              key: "result" + index,
                              staticClass: "result_item"
                            },
                            [
                              _c("img", {
                                staticClass: "result_image",
                                attrs: { src: img.file_url, alt: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.previewImage(img.file_url)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "result_info" }, [
                                _c("p", { staticClass: "result_model" }, [
                                  _vm._v(_vm._s(img.model_name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result_actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toImageToVideo(img)
                                          }
                                        }
                                      },
                                      [_vm._v("图生视频")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toAiEdit(img)
                                          }
                                        }
                                      },
                                      [_vm._v("AI改图")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toFavorite(img, index)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              img.is_favorited
                                                ? "取消收藏"
                                                : "收藏"
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDownload(img)
                                          }
                                        }
                                      },
                                      [_vm._v("下载")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.exampleList.length > 0
                  ? _c("div", { staticClass: "example_section" }, [
                      _c("div", { staticClass: "example_header" }, [
                        _c("h5", [_vm._v("优质案例")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "example_grid" },
                        _vm._l(_vm.exampleList, function(item) {
                          return _c(
                            "div",
                            {
                              key: "example" + item.id,
                              staticClass: "example_item",
                              on: {
                                click: function($event) {
                                  return _vm.previewExample(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    item.photo_url +
                                    "?x-oss-process=image/resize,w_300",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "提示词库",
                    visible: _vm.libraryVisible,
                    width: "70%",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.libraryVisible = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "library_description" }, [
                    _vm._v("选择预设的提示词来丰富你的描述")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "library_content" },
                    [
                      _c(
                        "el-tabs",
                        {
                          staticClass: "library_tabs",
                          model: {
                            value: _vm.libraryTab,
                            callback: function($$v) {
                              _vm.libraryTab = $$v
                            },
                            expression: "libraryTab"
                          }
                        },
                        _vm._l(_vm.promptCategories, function(category, index) {
                          return _c(
                            "el-tab-pane",
                            {
                              key: "category" + index,
                              attrs: {
                                label: category.name,
                                name: String(index)
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "library_tags" },
                                _vm._l(category.prompts, function(item, idx) {
                                  return _c(
                                    "el-button",
                                    {
                                      key: "prompt" + idx,
                                      staticClass: "library_button",
                                      attrs: {
                                        type: _vm.selectedLibraryItems.includes(
                                          item
                                        )
                                          ? "success"
                                          : "default",
                                        plain: !_vm.selectedLibraryItems.includes(
                                          item
                                        ),
                                        size: "small"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleLibraryToggle(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedLibraryItems.length > 0
                    ? _c(
                        "div",
                        { staticClass: "choose_list" },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("已选择：")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.selectedLibraryItems, function(
                            item,
                            index
                          ) {
                            return _c(
                              "el-tag",
                              {
                                key: "choose" + index,
                                attrs: {
                                  closable: true,
                                  "disable-transitions": true,
                                  type: "success"
                                },
                                on: {
                                  close: function($event) {
                                    return _vm.handleLibraryItemClose(index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item) +
                                    "\n          "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog_footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.libraryVisible = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            disabled: _vm.selectedLibraryItems.length === 0
                          },
                          on: { click: _vm.handleApplyLibrary }
                        },
                        [_vm._v("确定")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "图转提示词",
                    visible: _vm.imageToPromptVisible,
                    width: "600px",
                    "custom-class": "image-to-prompt-dialog",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.imageToPromptVisible = $event
                    }
                  }
                },
                [
                  _c("p", { staticClass: "hint_text" }, [
                    _vm._v(
                      "上传参考图或从素材库选择，AI 将自动生成详细的提示词描述"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "image_to_prompt_content" }, [
                    _c(
                      "div",
                      { staticClass: "select_method_buttons" },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "",
                              "auto-upload": false,
                              "show-file-list": false,
                              "on-change": _vm.handleImageUpload,
                              accept: "image/*"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { type: "success", plain: "" }
                              },
                              [
                                _c("i", { staticClass: "el-icon-upload" }),
                                _vm._v(" 上传图片\n              ")
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { type: "success", plain: "" },
                            on: { click: _vm.openMaterialLibrary }
                          },
                          [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" 从素材库选择\n            ")
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.uploadedImage
                      ? _c("div", { staticClass: "upload_preview_area" }, [
                          _c("div", { staticClass: "preview_label" }, [
                            _vm._v("预览图片")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "preview_image_wrapper" },
                            [
                              _c("img", {
                                attrs: { src: _vm.uploadedImage, alt: "预览图" }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "clear_btn",
                                  attrs: { size: "mini", type: "danger" },
                                  on: { click: _vm.clearUploadedImage }
                                },
                                [
                                  _c("i", { staticClass: "el-icon-delete" }),
                                  _vm._v(" 清除\n              ")
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.generatedPromptText
                      ? _c(
                          "div",
                          { staticClass: "generated_prompt_section" },
                          [
                            _c("h4", [_vm._v("生成的提示词（可编辑）")]),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 6,
                                placeholder: "AI 将自动生成提示词..."
                              },
                              model: {
                                value: _vm.generatedPromptText,
                                callback: function($$v) {
                                  _vm.generatedPromptText = $$v
                                },
                                expression: "generatedPromptText"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog_footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.imageToPromptVisible = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            disabled: !_vm.generatedPromptText
                          },
                          on: { click: _vm.handleApplyImagePrompt }
                        },
                        [_vm._v("应用到提示词")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择素材",
                    visible: _vm.materialLibraryVisible,
                    width: "80%",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.materialLibraryVisible = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "material_library_content" }, [
                    _c(
                      "div",
                      { staticClass: "material_filter" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.materialTypeChange },
                            model: {
                              value: _vm.materialType,
                              callback: function($$v) {
                                _vm.materialType = $$v
                              },
                              expression: "materialType"
                            }
                          },
                          [
                            _c("el-radio-button", { attrs: { label: "风格" } }),
                            _vm._v(" "),
                            _c("el-radio-button", {
                              attrs: { label: "空间类型" }
                            }),
                            _vm._v(" "),
                            _c("el-radio-button", {
                              attrs: { label: "公司案例" }
                            }),
                            _vm._v(" "),
                            _c("el-radio-button", {
                              attrs: { label: "项目案例" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.materialType == "风格"
                      ? _c(
                          "div",
                          { staticClass: "material_tags" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    -1 == _vm.materialStyleCur
                                      ? "success"
                                      : "info",
                                  effect: "light"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.materialStyleClick(-1)
                                  }
                                }
                              },
                              [_vm._v("全部")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.materialStyleData, function(
                              item,
                              index
                            ) {
                              return _c(
                                "el-tag",
                                {
                                  key: "mstyle" + index,
                                  attrs: {
                                    type:
                                      index == _vm.materialStyleCur
                                        ? "success"
                                        : "info",
                                    effect: "light"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.materialStyleClick(index)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.style_type))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.materialType == "空间类型"
                      ? _c(
                          "div",
                          { staticClass: "material_tags" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    -1 == _vm.materialSpaceCur
                                      ? "success"
                                      : "info",
                                  effect: "light"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.materialSpaceClick(-1)
                                  }
                                }
                              },
                              [_vm._v("全部")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.materialSpaceData, function(
                              item,
                              index
                            ) {
                              return _c(
                                "el-tag",
                                {
                                  key: "mspace" + index,
                                  attrs: {
                                    type:
                                      index == _vm.materialSpaceCur
                                        ? "success"
                                        : "info",
                                    effect: "light"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.materialSpaceClick(index)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.space_type))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.materialType == "公司案例"
                      ? _c(
                          "div",
                          { staticClass: "material_tags" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    -1 == _vm.materialCompanyCur
                                      ? "success"
                                      : "info",
                                  effect: "light"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.materialCompanyClick(-1)
                                  }
                                }
                              },
                              [_vm._v("全部")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.materialCompanyData, function(
                              item,
                              index
                            ) {
                              return _c(
                                "el-tag",
                                {
                                  key: "mcompany" + index,
                                  attrs: {
                                    type:
                                      index == _vm.materialCompanyCur
                                        ? "success"
                                        : "info",
                                    effect: "light"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.materialCompanyClick(index)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.project_type))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.materialType == "项目案例"
                      ? _c(
                          "div",
                          { staticClass: "material_tags" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    -1 == _vm.materialProjectCur
                                      ? "success"
                                      : "info",
                                  effect: "light"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.materialProjectClick(-1)
                                  }
                                }
                              },
                              [_vm._v("全部")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.materialProjectData, function(
                              item,
                              index
                            ) {
                              return _c(
                                "el-tag",
                                {
                                  key: "mproject" + index,
                                  attrs: {
                                    type:
                                      index == _vm.materialProjectCur
                                        ? "success"
                                        : "info",
                                    effect: "light"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.materialProjectClick(index)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.project_type))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.materialLoading,
                            expression: "materialLoading"
                          }
                        ],
                        staticClass: "material_grid"
                      },
                      _vm._l(_vm.materialData, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: "material" + index,
                            class: [
                              "material_item",
                              { selected: _vm.isMaterialSelected(item) }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.selectMaterial(item)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  item.photo_url +
                                  "?x-oss-process=image/resize,w_300",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _vm.isMaterialSelected(item)
                              ? _c("div", { staticClass: "material_overlay" }, [
                                  _c("i", { staticClass: "el-icon-check" })
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.materialData.length === 0 && !_vm.materialLoading
                      ? _c(
                          "div",
                          { staticClass: "empty_state" },
                          [
                            _c("el-empty", {
                              attrs: { description: "暂无素材" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog_footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.materialLibraryVisible = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            disabled: !_vm.selectedMaterial
                          },
                          on: { click: _vm.handleMaterialSelect }
                        },
                        [_vm._v("确定选择")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.previewVisible,
                    width: "auto",
                    "close-on-click-modal": true,
                    "custom-class": "image-preview-dialog",
                    "modal-append-to-body": true,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.previewVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "preview-dialog-image",
                    attrs: { src: _vm.previewImageUrl }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "示例详情",
                    visible: _vm.exampleDetailVisible,
                    width: "80%",
                    top: "5vh",
                    "close-on-click-modal": true,
                    "custom-class": "example-detail-dialog"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.exampleDetailVisible = $event
                    }
                  }
                },
                [
                  _vm.currentExample
                    ? _c("div", { staticClass: "example_detail" }, [
                        _c("div", { staticClass: "detail_left" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.currentExample.photo_url,
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail_right" }, [
                          _c("div", { staticClass: "detail_item" }, [
                            _c("label", [_vm._v("提示词/描述：")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.currentExample.description))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "detail_item" }, [
                            _c("label", [_vm._v("使用模型：")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.currentExample.model_name))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.currentExample.style_type
                            ? _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("风格类型：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.style_type))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentExample.space_type
                            ? _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("空间类型：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.space_type))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "detail_actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.useThisExample }
                                },
                                [_vm._v("使用此提示词")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29926f8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29926f8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TextToImage/Index.vue
// module id = null
// module chunks = 